// @flow
import * as React from 'react';
import { Box } from 'grommet';

type Props = {
    onClick?: () => any,
    pad?: string | Object,
    actions?: React.Node,
    children: React.Node,
    clickedRowIdentity?: string,
    rowId?: string,
    hoverIndicator?: string,
    childrenWidth?: string,
    contentMaxWidth?: string,
    padLevel?: 1 | 2 | 3,
}

const ContentRow = (props: Props) => {
    const {
        onClick, pad, actions, children, clickedRowIdentity, rowId, hoverIndicator, contentMaxWidth,
        padLevel, childrenWidth,
    } = props;

    let padValue;
    if (padLevel) {
        switch (padLevel) {
        case 1:
            padValue = '12px';
            break;
        case 2:
            padValue = 'medium';
            break;
        case 3:
            padValue = 'large';
            break;
        default:
            padValue = null;
        }
    }

    return (
        <Box
            onClick={onClick}
            pad={{ top: 'xxsmall' }}
            hoverIndicator={hoverIndicator}
            style={{ boxShadow: 'none' }}
            background={(rowId && rowId === clickedRowIdentity) ? 'light-3' : ''}
        >
            <Box
                pad={padValue ? { left: padValue } : pad}
                direction="row"
                align="center"
                justify="between"
            >
                <Box
                    direction="row"
                    pad={padValue ? { left: padValue } : pad}
                    align="center"
                    style={{ maxWidth: contentMaxWidth }}
                    width={childrenWidth}
                >
                    {children}
                </Box>
                {actions && (
                    <Box
                        align="center"
                        direction="row"
                        justify="end"
                    >
                        {actions}
                    </Box>
                )}
            </Box>
        </Box>
    );
};

ContentRow.defaultProps = {
    rowId: undefined,
    clickedRowIdentity: undefined,
    onClick: undefined,
    hoverIndicator: 'light-2',
    childrenWidth: undefined,
    pad: undefined,
    actions: undefined,
    contentMaxWidth: '80%',
    padLevel: undefined,
};

export default ContentRow;
